import { render, staticRenderFns } from "./DoctorPageLpuListMetroList.vue?vue&type=template&id=12868747&"
import script from "./DoctorPageLpuListMetroList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorPageLpuListMetroList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12868747')) {
      api.createRecord('12868747', component.options)
    } else {
      api.reload('12868747', component.options)
    }
    module.hot.accept("./DoctorPageLpuListMetroList.vue?vue&type=template&id=12868747&", function () {
      api.rerender('12868747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListMetroList.vue"
export default component.exports